import { Component, inject } from '@angular/core';
import * as XLSX from 'xlsx';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TemplatesService } from '../views/templates/templates.service';
import { QuestionModel } from '../Models/QuestionModel';
import { DropdownFiltersModel } from '../Models/DropdownFiltersModel';
import { AddProposalService } from '../views/proposals/add-proposal/add-proposal.service';
import { ProposalRepositoryService } from '../views/proposal-repository/proposal-repository.service';

@Component({
  selector: 'app-question-export',
  templateUrl: './question-export.component.html',
  styleUrls: ['./question-export.component.css']
})
export class QuestionExportComponent {

  selectedValue: string | undefined;
  fileUploadForm: FormGroup;
  customerNames: string[] = [];
  uniqueProposals: string[] = [];
  selectedData: { data: string, proposal: string, domain: string, selected: boolean }[] = [];
  isAllChecked: boolean = false;
  domainValue: string;
  recentItems: any;
  // firstTimeData:boolean=true;
  public searchText: string = '';
  public size: number = 9;
  public from: number = 0;
  public domains: any = [];
  proposalValue: string;


  constructor(private formBuilder: FormBuilder, private _proposalService: AddProposalService, private service: ProposalRepositoryService, private templateService: TemplatesService) {

  }



  ngOnInit() {
    this.fileUploadForm = this.formBuilder.group({
      fileType: ['', Validators.required],
      domain: ['', Validators.required],
      proposal: ['', Validators.required]
    });

    this.getDomains();
    this.getProposalData();

  }


  getDomains(): Promise<any[]> {
    this.domains = [];
    return new Promise<any[]>((resolve, reject) => {
      this._proposalService.getDomains().subscribe(x => {
        let y = x.data.items.map(item => item.name);
        this.domains = y;
        resolve(this.domains)
      });
    });
  }


  getProposalData() {
    this.service.getProposalData(null, this.searchText, this.from, this.size).subscribe(response => {
      this.recentItems = response.data.proposals;
      this.recentItems.forEach(item => {
        this.customerNames.push(item.customerName);
      });



      // Call GetOtherProposals inside the subscribe block to ensure it's called after getProposalData
      this.templateService.GetOtherProposals().subscribe(otherResponse => {
        this.combineProposals(otherResponse); // Assuming otherResponse contains the data you need
      });
    });
  }



  combineProposals(fetchedProposals: string[]): void {

    // Combine and remove duplicates using a Set
    const combinedProposals = new Set([...this.customerNames, ...fetchedProposals]);
    this.customerNames = Array.from(combinedProposals); // Assign combined unique proposals to customerNames

  }

  onSelected() {
    // api integration
    // this.getData();
    this.checkAllSelections();
  }
  domainChange() {
    this.checkAllSelections();

  }
  proposalChange() {
    this.checkAllSelections();

  }

  checkAllSelections() {
    if (this.selectedValue && this.domainValue && this.proposalValue) {
      this.getAllQuestions();
    }
  }

  getAllQuestions() {
    var properties = new DropdownFiltersModel();
    properties.fileType = this.selectedValue;
    properties.proposal = this.proposalValue;
    properties.domain = this.domainValue;

    this.templateService.GetQuestions(properties).subscribe((res: any) => {
      if (res && res.length > 0) {
        this.selectedData = res.flatMap((item: any) =>
          item.questionsList.map((question: any) => ({
            data: question.name,
            domain: item.domainType,
            proposal: item.proposal,
            selected: false
          }))
        );
        //this.firstTimeData=false;
      }
      else {
        this.selectedData = [];
        //this.firstTimeData=false;
      }
      //this.selectedData=res.questionsList[0].name
    })
  }



  checkAllSelected() {
    this.isAllChecked = this.selectedData.every(item => item.selected);
  }

  areAnyCheckboxesSelected(): boolean {
    return this.selectedData.some(item => item.selected);
  }

  selectAll(checked: boolean) {
    this.selectedData.forEach(item => (item.selected = checked));
    this.isAllChecked = checked;
  }

  isAllSelected() {
    return this.selectedData.length > 0 && this.selectedData.every(item => item.selected);
  }



  exportData() {
    const selectedItems = this.selectedData.filter(item => item.selected);

    // Add the new column data and map it along with existing data
    const numberedItems = selectedItems.map((item, index) => [index + 1, item.data, item.proposal, item.domain]);

    // Add headers for columns, including the new column
    numberedItems.unshift(['No', this.selectedValue, 'proposal', 'Domain']);

    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(numberedItems);

    // Set column widths (in characters) for columns A, B, C, and D
    const columnWidths = [{ wch: 8 }, { wch: 25 }, { wch: 25 }, { wch: 20 }];
    ws['!cols'] = columnWidths;

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Exported Data');

    const fileName = `exported_data_${new Date().getTime()}.xlsx`;

    XLSX.writeFile(wb, fileName);
  }





}
